
<mat-card class="one-card-flat" oneCard style="position:relative">
  <one-table class="recipient-table-wrap">
    <one-table-content class="scrollable-table">
      <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows mat-paginator class="cn-recepients-table" (matSortChange)="announceSortChange($event)">
        <ng-container matColumnDef="select">
        
          <th mat-header-cell *matHeaderCellDef>
           <mat-checkbox
              (change)="$event ? masterToggle() : null; validateBtnDeleteState()"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
            >
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox
              (change)="$event ? selection.toggle(row) : null; selectedRow = row; validateBtnDeleteState()"
              (click)="$event.stopPropagation()"
              [checked]="selection.isSelected(row)"
              [disabled]="row.disabled"
            >
            </mat-checkbox>
          </td>
        </ng-container>
       
        <ng-container matColumnDef="customerId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by customerId" style="max-width: 140px;">Account ID</th>
          <td mat-cell *matCellDef="let element" style="max-width: 140px;text-align:center">
            <div class="truncate-text" [title]="element.customerId">
              {{element.customerId}}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="customerName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by customerName">Account name</th>
          <td mat-cell *matCellDef="let element" style="text-align:center">
            <div class="truncate-text" [title]="element.customerName">
              {{element.customerName}}
            </div>           
          </td>
        </ng-container>
     
        <ng-container matColumnDef="customerContactName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by customerContactName">Account contact name</th>
          <td mat-cell *matCellDef="let element" style="text-align:center">
            <div class="truncate-text" [title]="element.customerContactName">
              {{element.customerContactName}}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="customerEmail">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by customerEmail">Account contact email</th>
          <td mat-cell *matCellDef="let element" style="text-align:center">
            <span class="truncate-text" [title]="element.customerEmail">
              {{element.customerEmail}}
            </span>
            <!-- <div class="truncate-text">{{ element.customerEmail }}</div> -->
          </td>
        </ng-container>

        <ng-container matColumnDef="sourceName" style="display: flex;">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by sourceName" style="justify-content: center;">Source</th>       
          <td mat-cell *matCellDef="let element" style="justify-content: center; text-align:center">            
              <div mat-chip class="rcp-list-source-chip truncate-text" oneChip oneChipAppearance="outline" [title]="element.sourceName">
                {{element.sourceName}}
              </div>            
            </td>          
        </ng-container>

        <ng-container matColumnDef="expandTrigger">
          <th *matHeaderCellDef mat-header-cell></th>
          <td (click)="expandToggle(element)" *matCellDef="let element" mat-cell 
            [ngStyle]="{'pointer-events': isDuplicated(dataSource.data, element) || isEmpty(element)? 'all': 'none'}"
            >
            <div *ngIf="isDuplicated(dataSource.data, element) || isEmpty(element)" class="icon-div">
              <div title="Duplicate recipient warning" style="height: 24px;">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" style="width: 24px;"><path fill="#D0342C" d="M21.912 20.173L12.813 3.478c-.265-.442-.795-.618-1.237-.353a.69.69 0 0 0-.353.353L2.125 20.173c-.265.442-.089.972.353 1.237.088.088.265.088.442.088h18.197c.53 0 .883-.441.883-.883 0-.177 0-.265-.088-.442zm-9.01-2.208h-1.767v-1.767H12.9v1.767zm0-3.534h-1.767v-5.3H12.9v5.3z"></path></svg>
              </div>
              <button *ngIf="element == expandedElement" one-icon-button mat-icon-button>
                <mat-icon>arrow_up</mat-icon>
              </button>
              <button *ngIf="element != expandedElement" one-icon-button mat-icon-button>
                <mat-icon>arrow_down</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td *matCellDef="let element" [attr.colspan]="displayedColumns.length" mat-cell>
            <div *ngIf="isDuplicated(dataSource.data, element) || isEmpty(element)">
              <div [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'" class="one-element-detail" style="display: flex; gap: 10px;">
                <div class="one-element-detail-content mat-caption" *ngIf="isDuplicatedEmail(dataSource.data, element)">
                  Duplicated contact email for the same Account ID.
                </div>
                <div class="one-element-detail-content mat-caption" *ngIf="isDuplicatedName(dataSource.data, element)">
                  Different Account name for existing Account ID.
                </div>
                <div class="one-element-detail-content mat-caption" *ngIf="isEmpty(element)">
                  Fields cannot be empty or blank.
                </div>
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
          *matRowDef="let row; columns: displayedColumns; let i = dataIndex;"
          [ngClass]="{ 
            checked: selection.isSelected(row), 
            disabled: row.disabled
          }"
          class="one-element-row"
          mat-row
        ></tr>
        <tr
          *matRowDef="let row; columns: ['expandedDetail']"
          [ngClass]="{
            checked: selection.isSelected(row),
            expanded: isExpanded(row),
            collapsed: !isExpanded(row),
            disabled: row.disabled
          }"
          class="one-detail-row"
          mat-row
        ></tr>
      </table>
    </one-table-content>

    <one-table-content>
      <mat-paginator 
        [pageSize]="500"
        [pageSizeOptions]="[10, 50, 100, 200, 500]"
        showFirstLastButtons>
      </mat-paginator>
    </one-table-content>

    <one-table-footer>
      <button [disabled]="isDeleteBtnDisabled" mat-stroked-button one-secondary-button (click)="openDeleteConfirmDialog()">Delete from recipients list</button>

      <div class="import-dropdown-button">
        <div *ngIf="isImportBtnExpanded" class="btn-list">
          <button (click)="openDialog()" class="sub-btns">From file</button>
          <hr>
          <button (click)="fromRexisSap()" class="sub-btns">From Rexis/SAP</button>
        </div>
        <button (click)="btnImportClicked()" [class.btn-expanded]="isImportBtnExpanded" class="btn-import" mat-stroked-button one-secondary-button>
          <span>Import recipient list</span>
        </button>
      </div>
    
    </one-table-footer>
  </one-table>
</mat-card>

<ng-template #myTemplate>
  <div class="emptyRecipientAlertDialog">
    <!-- <mat-icon i18n-aria-label="@@buttons.icon-buttons-example-button" matSuffix >warning</mat-icon> -->
    <b>Recipient list upload is not possible.</b>
    <p>For the following recipients the email address is missing. Please correct the data and upload it again.</p>
    <table cellpadding="6px">
      <thead>
        <th>Row Index</th>
        <th>Account Id</th>
        <th>Account Name</th>
        <th>Account Contact Name</th>
      </thead>
      <tbody>
        <tr *ngFor="let recipient of emptyContactList.emptyDataRow">
          <td>{{ recipient.rowIndex }}</td>
          <td>{{ recipient.customerId }}</td>
          <td>{{ recipient.customerName }}</td>
          <td>{{ recipient.customerContactName }}</td>
        </tr>
      </tbody>
    </table>
    <div class="emptyDialogCloseDiv">
      <button color="primary" mat-flat-button i18n="@@input-dialog-example.ok-btn" (click)="closeEmptyAlertDialog()" >
        Ok
      </button>
    </div>

  </div>
</ng-template>
